import type { MobileTopBarNavPage } from './MobileTopBarNav.types';

const EXCLUDED_SLUGS = new Set(['rsvp', 'guests']);

export const selectMobileTopBarNavPages = (pages: ReadonlyArray<MobileTopBarNavPage>): ReadonlyArray<MobileTopBarNavPage> => {
  return pages.filter(p => !EXCLUDED_SLUGS.has(p.pageSlug));
};
